export default __webpack_public_path__ + "static/media/4_long.c19d8edb.svg";